export const EXCLUDED_BATCH_OPERATIONS = ['CarrierCallList', 'TrackingContextCard']
